import styled from 'styled-components';

const StyledTooltip = styled.section`
	.motif-tooltip-wrapper .motif-tooltip-trigger-wrap .motif-icon-button {
		width: 24px;
		height: 44px;
	}
	.color-tag .tag-title {
		max-width: 23rem;
	}
`;
const StyledElement = styled.section`
	display: flex;
	flex-direction: column;
`;
export {StyledTooltip, StyledElement};
